export const liveStreamRoleNames = {
  broadcaster: "broadcaster",
  "co-broadcaster": "co-broadcaster",
  "viewer-realtime": "viewer-realtime",
  "viewer-near-realtime": "viewer-near-realtime",
  "viewer-on-stage": "viewer-on-stage",
};
